import { Row } from 'react-bootstrap';

const ContainerRow = Row;

export default ContainerRow;
